document.addEventListener('DOMContentLoaded', function () {
    const printButton = document.getElementById('printButton');

    if (printButton) {
        printButton.addEventListener('click', itemCardPrint);
    }
});


export function itemCardPrint() {
    window.scrollTo(0, 0);
    setTimeout(function () {

        // Starten Sie den Druck
        window.print();
    }, 500); // Hier 500 Millisekunden als Beispiel, Sie können dies anpassen
}